import { z } from 'zod';
/**
 * `POST /internal/sprout/shifts` body, sent by tools/sprout-employees.
 * Times are Sprout's own values: PH wall-clock with no offset, or null on a
 * rest/no-shift day. Their shape is checked per doer in the route, not here,
 * so one malformed day fails that doer and not the whole batch.
 */
const wallClockOrNull = z.string().max(32).nullable();
export const SproutShiftIngestDaySchema = z.object({
    date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    shift_start: wallClockOrNull,
    shift_end: wallClockOrNull,
    break_start: wallClockOrNull,
    break_end: wallClockOrNull,
    is_rest_day: z.boolean(),
    has_leave: z.boolean(),
    is_holiday: z.boolean(),
    status: z.string().max(64).nullable(),
});
export const SproutShiftIngestDoerSchema = z.object({
    sprout_employee_id: z.string().min(1).max(64),
    result: z.enum(['ok', 'not_in_sprout', 'separated']),
    days: z.array(SproutShiftIngestDaySchema).max(60),
});
export const SproutShiftIngestBodySchema = z.object({
    synced_at: z.string().datetime({ offset: true }),
    doers: z.array(SproutShiftIngestDoerSchema).min(1).max(500),
});
//# sourceMappingURL=sprout-shift-ingest.js.map